import React from "react";
import { Calendar, X } from "lucide-react";

const DateRangeFilter = ({ fromDate, toDate, onFromChange, onToChange, onClear }) => {
  const hasRange = fromDate || toDate;

  return (
    <div className="flex flex-col sm:flex-row gap-2 w-full sm:w-auto">
      <div className="relative flex-1 sm:flex-none">
        <Calendar
          size={14}
          className="absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none"
          style={{ color: "#d97706" }}
        />
        <input
          type="date"
          value={fromDate}
          onChange={(e) => onFromChange(e?.target?.value)}
          className="w-full sm:w-40 pl-8 pr-3 py-2 text-sm border border-[#f3e8d0] rounded-lg bg-white text-[#1f2937] focus:outline-none focus:ring-2 focus:ring-amber-400 focus:border-transparent"
          placeholder="From date"
        />
      </div>
      <div className="relative flex-1 sm:flex-none">
        <Calendar
          size={14}
          className="absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none"
          style={{ color: "#d97706" }}
        />
        <input
          type="date"
          value={toDate}
          onChange={(e) => onToChange(e?.target?.value)}
          className="w-full sm:w-40 pl-8 pr-3 py-2 text-sm border border-[#f3e8d0] rounded-lg bg-white text-[#1f2937] focus:outline-none focus:ring-2 focus:ring-amber-400 focus:border-transparent"
          placeholder="To date"
        />
      </div>
      {hasRange && (
        <button
          onClick={onClear}
          className="flex items-center gap-1 text-xs text-[#ff8c00] hover:text-amber-700 font-medium self-center whitespace-nowrap"
        >
          <X size={12} />
          Clear dates
        </button>
      )}
    </div>
  );
};

export default DateRangeFilter;
